import { apiClient } from './client';

export interface Perimeter {
  id: number;
  name: string;
  displayName: string;
  description?: string;
  logo?: string;
  isActive: boolean;
  settings?: Record<string, any>;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePerimeterRequest {
  name: string;
  displayName: string;
  description?: string;
  settings?: Record<string, any>;
}

export interface UpdatePerimeterRequest {
  displayName?: string;
  description?: string;
  isActive?: boolean;
  settings?: Record<string, any>;
}

export const perimetersApi = {
  /**
   * Récupérer tous les périmètres (SUPERADMIN uniquement)
   */
  async getAll() {
    return apiClient.get<Perimeter[]>('/perimeters');
  },

  // Compat: alias utilisé par certaines pages (ex: Users.tsx)
  async getPerimeters() {
    return apiClient.get<Perimeter[]>('/perimeters');
  },

  /**
   * Récupérer un périmètre par ID
   */
  async getById(id: number) {
    return apiClient.get<Perimeter>(`/perimeters/${id}`);
  },

  /**
   * Créer un nouveau périmètre (SUPERADMIN uniquement)
   */
  async create(data: CreatePerimeterRequest) {
    return apiClient.post<Perimeter>('/perimeters', data);
  },

  /**
   * Mettre à jour un périmètre
   */
  async update(id: number, data: UpdatePerimeterRequest) {
    return apiClient.put<Perimeter>(`/perimeters/${id}`, data);
  },

  /**
   * Uploader un logo pour un périmètre
   */
  async uploadLogo(id: number, file: File) {
    // Laisser le navigateur définir le boundary multipart
    return apiClient.uploadFile<{ message: string; logoUrl: string; perimeter: any }>(
      `/perimeters/${id}/logo`,
      file
    );
  },

  /**
   * Supprimer un logo
   */
  async deleteLogo(id: number) {
    await apiClient.delete(`/perimeters/${id}/logo`);
  },

  /**
   * Supprimer un périmètre
   */
  async delete(id: number) {
    await apiClient.delete(`/perimeters/${id}`);
  },
};

// Export named export for compatibility
export const perimeterService = perimetersApi;
